import { Alert, Button, Spin } from 'antd'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { TbFolders } from 'react-icons/tb'
import { Navigate } from 'react-router-dom'

import { diskFolderUrl } from '../Helpers/diskRoutes'
import { diskBrowserStore as store } from '../Stores/DiskBrowserStore'
import { withDiskFeature } from '../Helpers/diskFeature'

import type { IPageConfig } from '@/Core/Contracts/Loaders/IPageConfig'

/**
 * «Диск» у меню веде сюди, а сторінка одразу відкриває «Мій диск»
 * (`DISK-001` §6). Адреса особистого простору — його uuid, тож спершу
 * читаємо простори; той самий стор потім показує екран без повторного запиту.
 */
const IndexPage = observer(() => {
    useEffect(() => {
        document.title = 'Диск'
        void store.loadStorages()
    }, [])

    const target = store.personalStorage ?? store.storages[0]

    if (target) return <Navigate replace to={diskFolderUrl(target.uuid)} />

    if (store.storagesError !== null) {
        return (
            <div style={{ padding: 16 }}>
                <Alert
                    type="error"
                    showIcon
                    title={store.storagesError}
                    action={
                        <Button size="small" onClick={() => void store.loadStorages(true)}>
                            Повторити
                        </Button>
                    }
                />
            </div>
        )
    }

    if (store.storagesLoaded) {
        return (
            <div style={{ padding: 16 }}>
                <Alert type="warning" showIcon title="Для вас ще не створено жодного простору диска" />
            </div>
        )
    }

    return (
        <div style={{ padding: 48, textAlign: 'center' }}>
            <Spin />
        </div>
    )
})

export default withDiskFeature(IndexPage)

export const pageConfig: IPageConfig = {
    key: 'Disk.Index',
    route: '/disk',
    title: 'Диск',
    icon: <TbFolders />,
}
